import httpClient from "@/store/httpClient";

export default {
    namespaced: true,
    state: {
        menuItems: [],
        materialien: [],
        searchMaterials: [],
        contactPersons: [],
        dashboardPosts: [],
        sponsoringContactPersons: [],
    },
    mutations: {
        SET_MENU_ITEMS(state, menuItems) {
            state.menuItems = menuItems;
        },
        SET_MATERIALIEN(state, materialien) {
            state.materialien = materialien;
        },
        SET_SEARCH_MATERIALS(state, materialien) {
            state.searchMaterials = materialien;
        },
        SET_CONTACT_PERSONS(state, contactPersons) {
            state.contactPersons = contactPersons;
        },
        SET_DASHBOARD_POSTS(state, posts) {
            state.dashboardPosts = posts;
        },
        SET_SPONSORING_CONTACTS(state, contactPersons) {
            state.sponsoringContactPersons = contactPersons;
        }
    },
    getters: {
        getMaterialById: (state) => (id) => {
            return state.materialien.find(material => material.id === id);
        },
        getMenuItemById: (state) => (id) => {
            const menuItem = state.menuItems.find(item => item.id === id);
            return menuItem ? menuItem : null;
        },
        themen: (state) => {
            return [... new Set(state.materialien
                .map(material => material.Themas.map(t => t.Name))
                .flat())].toSorted();
        }
    },
    actions: {
        async loadMenuItems({ commit }) {
            const response = await httpClient.get("/bildungsportal/menu");

            if (response.status !== 200) return;

            await commit("SET_MENU_ITEMS", response.data
                .sort((a, b) => a.Sortierung ?? 0 - b.Sortierung ?? 0)
            );
        },
        async loadMaterialien({ commit }, id) {
            const url = `/bildungsportal/find?type=${id}`;

            const response = await httpClient.get(url);

            if (response.status !== 200) return;

            await commit("SET_MATERIALIEN", response.data);
        },
        async loadMaterialById({ commit, getters, state }, id) {
            const response = await httpClient.get(`/bildungsportal/by-id?id=${id}`);

            if (response.status !== 200) return;

            const responseMaterials = Array.isArray(response.data)
                ? response.data
                : [response.data].filter(Boolean);

            if(!getters.getMaterialById(id)) {
                const existingMaterials = Array.isArray(state.materialien)
                    ? state.materialien
                    : [];
                const mergedMaterials = [...existingMaterials];

                for (const material of responseMaterials) {
                    if (!mergedMaterials.find((entry) => entry.id === material.id)) {
                        mergedMaterials.push(material);
                    }
                }

                await commit("SET_MATERIALIEN", mergedMaterials);
            }
        },
        async loadSearchMaterials({ commit }) {
            try {
                const response = await httpClient.get('/bildungsportal/search-materials');

                if (response.status === 200 && Array.isArray(response.data)) {
                    await commit('SET_SEARCH_MATERIALS', response.data);
                    return;
                }
            } catch (_) {
                // fallback to legacy loading below
            }

            const menuResponse = await httpClient.get('/bildungsportal/menu');

            if (menuResponse.status !== 200 || !Array.isArray(menuResponse.data)) {
                await commit('SET_SEARCH_MATERIALS', []);
                return;
            }

            const materialsByType = await Promise.all(
                menuResponse.data.map((menuItem) =>
                    httpClient.get(`/bildungsportal/find?type=${menuItem.id}`)
                )
            );

            const mergedMaterials = materialsByType
                .filter((response) => response.status === 200 && Array.isArray(response.data))
                .map((response) => response.data)
                .flat();

            const seenIds = new Set();
            const uniqueMaterials = [];

            for (const material of mergedMaterials) {
                if (seenIds.has(material.id)) continue;
                seenIds.add(material.id);
                uniqueMaterials.push(material);
            }

            await commit('SET_SEARCH_MATERIALS', uniqueMaterials);
        },
        async loadContactPersons({ commit }) {
            const response = await httpClient.get("/bildungsportal-config");

            if (response.status !== 200) return;

            await commit("SET_CONTACT_PERSONS", response.data.Ansprechpartner);
            await commit("SET_SPONSORING_CONTACTS", response.data.SponsoringAnsprechpartner)
        },
        async sendContactMail(_, contactForm) {

            await httpClient.post("/bildungsportal/contact-mail", contactForm);
        },
        async loadDashboardPreviewPosts({ commit }) {
            const response = await httpClient.get("/bildungsportal-materials?_limit=5&_sort=created_at:desc");

            if (response.status !== 200) return;

            commit("SET_DASHBOARD_POSTS", response.data);
        }
    }
}
